import React, { useState } from "react";

const faqs = [
  {
    q: "What is BeyondLeadz?",
    a: "BeyondLeadz is SaaS based company that specializes in providing data and lead management solutions. We collect, clean, and organize data that can be used by businesses to improve their marketing, sales, and operational processes.",
  },
  {
    q: "What data is offered by BeyondLeadz?",
    a: "BeyondLeadz provides a wide range of data, including company profiles, contact information for key decision-makers, financial data, marketing and sales data, and more. We also offer custom data solutions to meet specific business needs.",
  },
  {
    q: "How is B2B data collected?",
    a: "Data is collected through various methods, such as web scraping, data mining, and surveys. We also have third party partners and purchase data from them.",
  },
  {
    q: "How can B2B data be used?",
    a: "Data can be used for various purposes, such as sales and marketing, market research, lead generation, and more. It can help businesses to better understand their target audience, identify potential customers, and make informed business decisions.",
  },
  {
    q: "How reliable is the data?",
    a: "The reliability of B2B data depends on the source of the data and the quality of the collection methods. We strictly use ethical and transparent methods for data collection and provide accurate and up-to-date data.",
  },
  {
    q: "How Accurate BeyondLeadz data is?",
    a: "Data provided is highly reliable and trustworthy with accuracy level up to 99%",
  },
  {
    q: "Can I integrate your data into my existing systems?",
    a: "Yes, BeyondLeadz offers integrations with popular CRM and marketing automation platforms. This allows businesses to easily import and use our B2B data within their existing systems.",
  },
  {
    q: "How is data priced?",
    a: "Our data is typically priced based on the quantity and credits of the data provided and offers subscription-based pricing models. The cost also varies based on the subscription package. So it's important to compare pricing and features across product variants.",
  },
  {
    q: "How can BeyondLeadz help my business?",
    a: "BeyondLeadz can help your business by providing accurate and up-to-date data that can be used to improve your marketing and sales processes. With the right data, you can target the right accounts and contacts, personalize your messaging, and increase your conversion rates. We also offer a robust Lead Management solution along-with to streamline your sales operations.",
  },
  {
    q: "How does BeyondLeadz collect its data?",
    a: "Beyondleadz collects its data from a variety of sources, such as public records, company websites, social media, and third-party data providers. We use advanced technology and data science techniques to ensure the accuracy and completeness of the data.",
  },
  {
    q: "Is the data provided by BeyondLeadz compliant with data protection regulations?",
    a: "Yes, BeyondLeadz takes data protection regulations seriously and ensures that the data provided is compliant with relevant regulations such as PDPB and CCPA.",
  },
  {
    q: "How can I evaluate the quality of data provided by a B2B data company?",
    a: "You can evaluate the quality of data provided by BeyondLeadz by looking at factors such as data accuracy, completeness, and timeliness. You can also look at customer reviews and testimonials to gauge the satisfaction of other businesses that have used the data. Alternatively you can register for Free Trial or ask for a quick sample.",
  },
  {
    q: "Can BeyondLeadz help me with data integration?",
    a: "Yes, we offer data integration services that can help you integrate data into your existing marketing and sales systems. Also you can integrate your third party applications to capture leads directly into our Lead Management feature.",
  },
  {
    q: "How can BeyondLeadz \"lead management\" feature help my business?",
    a: "A lead management can help your business by providing a systematic approach to managing your leads at one place. You can capture leads from multiple sources by automating and integrating them with BeyondLeadz.",
  },
  {
    q: "How does the lead feature work in BeyondLeadz?",
    a: "The lead feature typically works by integrating and collecting data from various sources to identify potential customers. This can include using data from customer websites, social media, and other online channels to capture leads. The data is then used by the businesses in a way that makes it easy to identify and reach out to potential customers.",
  },
  {
    q: "What is Intent Data offered by BeyondLeadz?",
    a: "The Intent Data can help your business by providing access to a database of potential customers who have shown interest in your products or services. This can help you target the right audience, improve your conversion rates, and ultimately grow your business.",
  },
  {
    q: "How accurate are the leads?",
    a: "The accuracy of the lead feature depends on the quality of the data sources used and the data analysis techniques employed. We use advanced technology and data science techniques to ensure the accuracy and completeness of your leads.",
  },
  {
    q: "What kind of information is included in the lead feature?",
    a: "Information includes a wide range of information about potential customers, such as their contact information, company size and industry, job title, online behavior, and more. This information can help businesses personalize their marketing messages and reach out to potential customers more effectively.",
  },
];

const Faq = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (idx) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section
      className="tw-py-20 lg:tw-py-28 tw-bg-slate-50/50 tw-border-t tw-border-solid tw-border-slate-100"
      id="faq"
    >
      <div className="tw-max-w-4xl tw-mx-auto tw-px-4 sm:tw-px-6 lg:tw-px-8">

        {/* Section header */}
        <div className="tw-text-center tw-mb-14">
          <span className="tw-inline-flex tw-items-center tw-gap-2 tw-text-xs tw-font-bold tw-text-[#5D44FF] tw-uppercase tw-tracking-widest tw-mb-4 tw-bg-indigo-50 tw-px-4 tw-py-1.5 tw-rounded-full tw-border tw-border-solid tw-border-indigo-100">
            <span className="tw-w-1.5 tw-h-1.5 tw-rounded-full tw-bg-[#5D44FF] tw-inline-block" />
            Help Center
          </span>
          <h2 className="tw-text-2xl sm:tw-text-3xl lg:tw-text-4xl tw-font-extrabold tw-text-slate-900 tw-leading-tight">
            Learn more from our{" "}
            <span className="tw-text-[#5D44FF]">FAQs</span>
          </h2>
          <p className="tw-text-slate-500 tw-mt-4 tw-text-base tw-max-w-xl tw-mx-auto">
            Find answers to the most common questions about BeyondLeadz, our data, and our platform.
          </p>
        </div>

        {/* Accordion */}
        <div className="tw-flex tw-flex-col tw-gap-4">
          {faqs.map((item, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div
                key={idx}
                className={`tw-bg-white tw-border tw-border-solid tw-rounded-2xl tw-shadow-sm tw-transition-all tw-duration-300 ${
                  isOpen
                    ? "tw-border-[#5D44FF]/40 tw-shadow-indigo-100"
                    : "tw-border-slate-100 hover:tw-border-[#5D44FF]/20 hover:tw-shadow-md"
                }`}
              >
                {/* Question row */}
                <button
                  onClick={() => toggle(idx)}
                  className="tw-w-full tw-flex tw-items-center tw-justify-between tw-gap-4 tw-px-6 tw-py-5 tw-text-left tw-bg-transparent tw-border-0 tw-cursor-pointer tw-group"
                  aria-expanded={isOpen}
                  id={`faq-btn-${idx}`}
                >
                  <span className="tw-flex tw-items-center tw-gap-4">
                    {/* Number badge */}
                    <span
                      className={`tw-flex-shrink-0 tw-w-8 tw-h-8 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-text-xs tw-font-extrabold tw-transition-colors tw-duration-200 ${
                        isOpen
                          ? "tw-bg-[#5D44FF] tw-text-white"
                          : "tw-bg-indigo-50 tw-text-[#5D44FF]"
                      }`}
                    >
                      {idx + 1}
                    </span>
                    <span
                      className={`tw-text-base tw-font-semibold tw-leading-snug tw-transition-colors tw-duration-200 ${
                        isOpen ? "tw-text-[#5D44FF]" : "tw-text-slate-800 group-hover:tw-text-[#5D44FF]"
                      }`}
                    >
                      {item.q}
                    </span>
                  </span>

                  {/* Chevron */}
                  <span
                    className={`tw-flex-shrink-0 tw-w-7 tw-h-7 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-transition-all tw-duration-300 ${
                      isOpen ? "tw-bg-[#5D44FF] tw-rotate-180" : "tw-bg-indigo-50"
                    }`}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className={`tw-w-3.5 tw-h-3.5 tw-transition-colors ${isOpen ? "tw-text-white" : "tw-text-[#5D44FF]"}`}
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth={2.5}
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                    </svg>
                  </span>
                </button>

                {/* Answer */}
                <div
                  className={`tw-overflow-hidden tw-transition-all tw-duration-300 ${
                    isOpen ? "tw-max-h-96 tw-opacity-100" : "tw-max-h-0 tw-opacity-0"
                  }`}
                >
                  <div className="tw-px-6 tw-pb-5 tw-pl-[4.5rem] tw-text-sm tw-text-slate-500 tw-leading-relaxed">
                    {item.a}
                  </div>
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default Faq;
